<template>
  <v-row justify="center">
    <v-dialog v-model="open" fullscreen :transition="false">
      <v-card height="100%" width="100%" class="globalLoadingCard">
        <v-container class="fill-height">
          <v-row
            class="d-flex flex-column pb-16"
            justify="center"
            align="center"
          >
            <span class="text-h6 mb-6" v-if="text.length">{{ text }}</span>
            <v-progress-circular
              :size="value * 0.8"
              width="1"
              indeterminate
              color="#DCDCDC"
            >
              <v-progress-circular
                :size="value * 0.6"
                width="1"
                indeterminate
                color="#DCDCDC"
                rotate="180"
              >
                <v-img
                  class="pulseAnimation"
                  src="@/assets/pandaMainLogo.svg"
                  :max-width="value * 0.5"
                ></v-img>
              </v-progress-circular>
            </v-progress-circular>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: 'GlobalLoading',
  data: function () {
    return {}
  },
  watch: {
    open: function () {
      setTimeout(() => {
        if (this.open) {
          this.$root.$emit('setGlobalLoading', { open: false, text: '' })
        }
      }, 15000)
    },
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: 200,
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.globalLoadingCard {
  opacity: 0.8;
}

.pulseAnimation {
  animation: pulse 2s linear infinite;
}

@keyframes pulse {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
